import { useTranslation } from 'react-i18next'
import { signOut } from 'aws-amplify/auth'
import { DropdownDivider, DropdownItem, DropdownLabel, DropdownMenu } from '../components'

import {
    ArrowRightStartOnRectangleIcon,
    LightBulbIcon,
    ShieldCheckIcon,
    UserCircleIcon,
} from '@heroicons/react/16/solid'

export function AppNavMenu({ anchor }) {
    const { t } = useTranslation()
    return (
        <DropdownMenu className="min-w-64" anchor={anchor}>
            {/* <DropdownItem href="#">
                <UserCircleIcon />
                <DropdownLabel>{t("My Account")}</DropdownLabel>
            </DropdownItem>
            <DropdownDivider />
            <DropdownItem href="#">
                <ShieldCheckIcon />
                <DropdownLabel>
                    {t("Privacy policy")}
                </DropdownLabel>
            </DropdownItem>
            <DropdownItem href="#">
                <LightBulbIcon />

                <DropdownLabel>
                    {t("Share feedback")}
                </DropdownLabel>
            </DropdownItem> */}
            {/* <DropdownDivider /> */}
            <DropdownItem
                href="#"
                onClick={async () => {
                    await signOut()
                    window.location.href = '/'
                }}
            >
                <ArrowRightStartOnRectangleIcon />
                <DropdownLabel>{t('Sign out')}</DropdownLabel>
            </DropdownItem>
        </DropdownMenu>
    )
}
